import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import { motion } from 'framer-motion';
import styled from 'styled-components';
var SearchResultContainer = styled(motion.div)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  top: ", "px;\n  left: 0;\n  width: 100%;\n  z-index: ", ";\n  overflow: hidden;\n  @media (max-width: ", "px) {\n    height: 100%;\n  }\n  @media (min-width: ", "px) {\n    position: absolute;\n    top: ", ";\n  }\n"], ["\n  position: fixed;\n  top: ", "px;\n  left: 0;\n  width: 100%;\n  z-index: ", ";\n  overflow: hidden;\n  @media (max-width: ", "px) {\n    height: 100%;\n  }\n  @media (min-width: ", "px) {\n    position: absolute;\n    top: ", ";\n  }\n"])), function (props) {
  var _a;

  return (_a = props.mobileTopPosition) !== null && _a !== void 0 ? _a : 0;
}, function (props) {
  var _a;

  return (_a = props.theme.constants) === null || _a === void 0 ? void 0 : _a.searchModalZIndex;
}, function (props) {
  var _a;

  return (_a = props.theme.constants) === null || _a === void 0 ? void 0 : _a.headerBreakpoint;
}, function (props) {
  var _a;

  return (_a = props.theme.constants) === null || _a === void 0 ? void 0 : _a.headerBreakpoint;
}, function (props) {
  var _a, _b;

  return (_a = props.topPosition) !== null && _a !== void 0 ? _a : "calc(100% + ".concat((_b = props.theme.spacings) === null || _b === void 0 ? void 0 : _b.xs, "px)");
});
var SearchRightLabel = styled(motion.div)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n"], ["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n"])));
var SearchBarContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n\n  position: relative;\n  display: flex;\n  justify-content: flex-end;\n"], ["\n  ", ";\n\n  position: relative;\n  display: flex;\n  justify-content: flex-end;\n"])), function (props) {
  return props.flexGrow && "flex: 1;";
});
var SearchInput = styled.input(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  flex: 1;\n  border: none;\n  background: transparent;\n  outline: none;\n  font-size: ", "px;\n  padding: ", "px;\n  line-height: ", "px;\n  ::placeholder {\n    /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: ", ";\n    opacity: 1; /* Firefox */\n  }\n\n  :-ms-input-placeholder {\n    /* Internet Explorer 10-11 */\n    color: ", ";\n  }\n\n  ::-ms-input-placeholder {\n    /* Microsoft Edge */\n    color: ", ";\n  }\n"], ["\n  flex: 1;\n  border: none;\n  background: transparent;\n  outline: none;\n  font-size: ", "px;\n  padding: ", "px;\n  line-height: ", "px;\n  ::placeholder {\n    /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: ", ";\n    opacity: 1; /* Firefox */\n  }\n\n  :-ms-input-placeholder {\n    /* Internet Explorer 10-11 */\n    color: ", ";\n  }\n\n  ::-ms-input-placeholder {\n    /* Microsoft Edge */\n    color: ", ";\n  }\n"])), function (props) {
  var _a, _b;

  return props.inputSize === 'small' ? (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.size.s2 : (_b = props.theme.typography) === null || _b === void 0 ? void 0 : _b.size.s3;
}, function (props) {
  var _a, _b;

  return props.inputSize === 'small' ? (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xs : (_b = props.theme.spacings) === null || _b === void 0 ? void 0 : _b.xs2;
}, function (props) {
  var _a;

  return (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.size.m1;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.mediumDark;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.mediumDark;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.mediumDark;
});
var MobileSearchFormContainer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background: ", ";\n  padding: ", ";\n  @media (min-width: ", "px) {\n    display: none;\n  }\n"], ["\n  background: ", ";\n  padding: ", ";\n  @media (min-width: ", "px) {\n    display: none;\n  }\n"])), function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.white;
}, function (props) {
  var _a;

  return "".concat((_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xs, "px 10px");
}, function (props) {
  var _a;

  return (_a = props.theme.constants) === null || _a === void 0 ? void 0 : _a.headerBreakpoint;
});
var SearchForm = styled.form(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  flex: 1;\n  display: ", ";\n  padding: ", ";\n  background: ", ";\n  border-radius: ", "px;\n  box-shadow: inset 0 0 0 1px ", ";\n\n  &:focus-within {\n    box-shadow: inset 0 0 0 1px ", ";\n    background: ", ";\n  }\n  > div[data-lastpass-icon-root] {\n    display: none;\n  }\n  @media (min-width: ", ") {\n    &:hover {\n      background: ", ";\n    }\n  }\n  @media (min-width: ", "px) {\n    display: flex;\n\n    flex-direction: row;\n    padding-left: ", "px;\n    padding-right: ", "px;\n    ", "\n  }\n"], ["\n  flex: 1;\n  display: ", ";\n  padding: ", ";\n  background: ", ";\n  border-radius: ", "px;\n  box-shadow: inset 0 0 0 1px ", ";\n\n  &:focus-within {\n    box-shadow: inset 0 0 0 1px ", ";\n    background: ", ";\n  }\n  > div[data-lastpass-icon-root] {\n    display: none;\n  }\n  @media (min-width: ", ") {\n    &:hover {\n      background: ", ";\n    }\n  }\n  @media (min-width: ", "px) {\n    display: flex;\n\n    flex-direction: row;\n    padding-left: ", "px;\n    padding-right: ", "px;\n    ", "\n  }\n"])), function (props) {
  return props.hideInMobile ? 'none' : 'flex';
}, function (props) {
  var _a;

  return "0px ".concat((_a = props.theme.constants) === null || _a === void 0 ? void 0 : _a.searchBarHorizontalPadding, "px");
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.white;
}, function (props) {
  var _a;

  return (_a = props.theme.attributes) === null || _a === void 0 ? void 0 : _a.borderRadius.small;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.disabledGray;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.brandBlue;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.white;
}, function (props) {
  var _a;

  return (_a = props.theme.breakpoints) === null || _a === void 0 ? void 0 : _a.sm;
}, function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.lightest;
}, function (props) {
  var _a;

  return (_a = props.theme.constants) === null || _a === void 0 ? void 0 : _a.headerBreakpoint;
}, function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.sm;
}, function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.sm;
}, function (props) {
  return props.isOpen && "\n       flex-direction: row;\n    ";
});
var MobileSearchIconContainer = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: block;\n  @media (min-width: ", "px) {\n    display: none;\n  }\n"], ["\n  display: block;\n  @media (min-width: ", "px) {\n    display: none;\n  }\n"])), function (props) {
  var _a;

  return (_a = props.theme.constants) === null || _a === void 0 ? void 0 : _a.headerBreakpoint;
});
var SearchLeftIcon = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
export { MobileSearchFormContainer, MobileSearchIconContainer, SearchBarContainer, SearchForm, SearchInput, SearchLeftIcon, SearchResultContainer, SearchRightLabel };